import { useQuery } from 'react-query';
import { getApi } from '../../../../config/SwaggerApi';
import { configQueryReactSimpleRequest } from '../../../core/hooks/useCodeTables/config';



const asiteStatusesByWorkspaceNameQueryFn = (workspaceName: string) => {
    return getApi().asite.asiteGetAsiteDocumentStatusesByWorkspaceNameGet({
        workspaceName,
    })
        .then((response) => response.data);
}


const useAsiteStatusesByWorkspaceNameQuery = (workspaceName: string) => {
    const asiteStatusesByWorkspaceNameQuery = useQuery(
        ['codeTable-attributes', workspaceName],
        () => asiteStatusesByWorkspaceNameQueryFn(workspaceName),
        { ...configQueryReactSimpleRequest, enabled: !!workspaceName }
    );

    return asiteStatusesByWorkspaceNameQuery;
};

export default useAsiteStatusesByWorkspaceNameQuery;
